module.exports = __webpack_public_path__ + "static/img/jiadian.8b988ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/jiadian.jpg
// module id = 386
// module chunks = 12